import { Box } from '@mui/material'
import ButtonMobileComponent from 'components/button-mobile'
import InputMobileComponent from 'components/input-mobile'
import { useEffect, useState } from 'react'
import { UpdateSchoolInputProps } from 'types/SchoolTypes'
import { isValidUrl } from 'utils/validations'
import SettingsBox from './SettingsBox'

interface WebsiteLinkSettingsProps {
  initialSchoolAdminLink?: string
  onSave: (body: UpdateSchoolInputProps, loadingMsg?: string, cb?: () => void) => Promise<void>
}

function WebsiteLinkSettings({ initialSchoolAdminLink = '', onSave }: WebsiteLinkSettingsProps) {
  const [schoolAdminLink, setSchoolAdminLink] = useState<string>(initialSchoolAdminLink)

  // Sync local state with props when props change
  useEffect(() => {
    setSchoolAdminLink(initialSchoolAdminLink)
  }, [initialSchoolAdminLink])

  // hasChanges is always derived
  const hasChanges = schoolAdminLink !== initialSchoolAdminLink

  // Handlers
  const isInvalid = !isValidUrl(schoolAdminLink)

  const handleSave = async () => {
    if (hasChanges && !isInvalid) {
      await onSave({ schoolAdminLink }, 'Updating web link...')
    }
  }

  return (
    <SettingsBox title='School Carpool Program Link' subtitle='Link to Additional Information for Families'>
      <InputMobileComponent
        placeholder='https://yourdomain.com/family-info'
        helperText={'This link will be featured on the parent dashboard.'}
        value={schoolAdminLink}
        isError={isInvalid}
        onChange={(v: string) => setSchoolAdminLink(v.trim())}
        data-testid='school-admin-link'
      />

      {hasChanges && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
          <ButtonMobileComponent text='Save' width='w-[100px]' disabled={isInvalid} onClick={handleSave} />
        </Box>
      )}
    </SettingsBox>
  )
}

export default WebsiteLinkSettings
